export const apiUrls = {
  generateTokensWizardUrl: () => {
    return `/v2/user/form/member/user/search/generate`;
  },
  generateWizardUrl: () => {
    return `/v2/user/form/member/user/group/generate`;
  },
  loginAsWizardUrl: () => {
    return `/v2/user/form/member/user/loginAs`;
  },
  exportMemberUsersUrl: () => {
    return `/v2/user/members/users/export`;
  },
  newMemberUserUrl: () => {
    return `/v2/user/members/ui/new`;
  },
  editMemberUserUrl: (userKey) => {
    return `/v2/user/members/ui/edit/${userKey}`;
  },
  copyMemberUserUrl: (userKey) => {
    return `/v2/user/members/ui/copy/${userKey}`;
  },
  deleteMemberUserUrl: () => {
    return `/v2/user/members/ui/delete`;
  },
  securityLoginAsUrl: () => {
    return `security/marketplace/group-login-as`;
  },
};

export const moduleUrls = {
  memberUserWizardUrl: () => {
    return `/member-module/user-administration/form`;
  },
  userAdministrationUrl: () => {
    return `/member-module/user-administration`;
  },
};
